class ProductOptionsGenerator {
  constructor(options, containerId) {
    this.options = options;
    this.container = document.getElementById(containerId);

    
    if (!this.container) {
      console.error(`El contenedor con ID ${containerId} no existe.`);
      return;
    }
    
    this.section_id = document.getElementById(containerId).getAttribute("section-related");
    this.selectedOptions = {}; // Para almacenar las opciones seleccionadas
    this.renderOptions();
  }

  renderOptions() {
    Object.entries(this.options).forEach(([key, values], index) => {
      const section = document.createElement("div");
      section.id = `F${index + 1}`;
      section.className = "product-section-option";
      section.dataset.foption = `F${index + 1}`;
      section.dataset.type = "color";
      section.style.order = index + 1;

      section.innerHTML = `
        <div class="product-section-option-header">
          <h4 class="ellip ellip-2 product-section-title">${key}</h4>
          <div class="helper-error">
            <i class="fas fa-exclamation-circle"></i>
            <span>Por favor elige ${key}</span>
          </div>
        </div>
        <div class="product-section-container" data-isprintcolorwidget="false">
          ${this.generateOptions(values, key)}
        </div>
        <div class="fa-3x start-loading">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      `;

      this.container.appendChild(section);
    });
  }

  generateOptions(values, key) {
    return values.map((value, idx) => {
      let colorStyle = this.getColorGradient(value);

      return `
        <div class="product-option product-option-colorpicker ${idx === 0 ? "active" : ""} not-division" data-option-text="${value}">
          <div class="product-option-img d-none"></div>
          <div class="product-option-body">
            <div class="product-option-title-price">
              <div style="display: flex; flex-direction: column">
                <span class="product-option-title">${value}</span>
                <span class="product-prices d-none"></span>
              </div>
              <span class="product-option-color" style="${colorStyle}"></span>
            </div>
            <span class="product-option-description d-none"></span>
          </div>
        </div>
      `;
    }).join("");
  }

  getColorGradient(value) {
    if (value === "Colores") {
      return "background: linear-gradient(125deg,#0ff 21%,#f0f 49%,#ff0 76%)";
    } else if (value === "En Blanco Y Negro") {
      return "background: linear-gradient(125deg,#000 9%,#fff 73%)";
    }
    return "";
  }

  // Método para manejar la selección
  handleOptionClick(event) {
    // Asegurarse de que el clic ocurrió sobre un item de la opción
    const item = event.target.closest('.product-section-container-item');
    if (item) {
      // Seleccionar el contenedor más cercano y añadir la clase active
      const sectionItems = item.closest('.product-section-container').querySelectorAll('.product-section-container-item');
      
      // Remover 'active' de todos los items
      sectionItems.forEach((el) => el.classList.remove('active'));

      // Añadir la clase 'active' al item clickeado
      item.classList.add('active');

      // Obtener el valor de la opción seleccionada
      const optionKey = item.dataset.optionKey;
      const optionValue = item.dataset.optionValue;

      // Actualizar la opción seleccionada
      this.selectedOptions[optionKey] = optionValue;
      this.updateAddToCartForm();
    }
  }

  updateAddToCartForm() {
    // Aquí puedes enlazar con el formulario de "add to cart"
    console.log("Opciones seleccionadas para agregar al carrito:", this.selectedOptions);
    // Lógica para pasar los datos al formulario de add to cart
  }
}

// JSON con opciones de producto
const productOptions = {
  "Forma": ["Rectangular", "Cuadrangular"],
  "Tamaño": ["90 x 50 mm", "85 x 55 mm"],
  "Material": ["Couché 350 g", "Cartulina Sulfatada 270 g"],
  "Color de impresión": ["En Blanco Y Negro"],
  "Lados impresos": ["Frente y Vuelta", "Solo frente"],
  "Refinamiento": ["Sin acabado", "Plastificado Mate"]
};

// Inicializar la clase cuando el DOM esté cargado
document.addEventListener("DOMContentLoaded", function () {
  const productOptionsGenerator = new ProductOptionsGenerator(productOptions, "options-container");

  // Agregar el evento de clic para cada opción
  document.getElementById("options-container")?.addEventListener("click", (event) => {
    productOptionsGenerator.handleOptionClick(event);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.qty-row').forEach(row => {
    row.addEventListener('click', () => {
      document.querySelectorAll('.qty-row').forEach(r => r.classList.remove('active'))
      row.classList.add('active')
      const qty = row.getAttribute('data-qty')
      document.getElementById('variantQtyInput').value = qty
    })
  })
})

document.addEventListener('DOMContentLoaded', function() {
  const propertiesContainer = document.getElementById('properties-container');
  const propertiesData = JSON.parse(document.getElementById('product-properties').textContent);
  const form = document.querySelector('form[action="/cart/add"]');
  
  // Agrupar propiedades por tipo
  const propertiesByType = propertiesData.properties.reduce((acc, property) => {
    if (!acc[property.type]) {
      acc[property.type] = [];
    }
    acc[property.type].push(property);
    return acc;
  }, {});
  
  // Crear la estructura HTML
  Object.entries(propertiesByType).forEach(([type, properties]) => {
    const groupDiv = document.createElement('div');
    groupDiv.className = 'property-group';
    groupDiv.dataset.type = type;
    
    const title = document.createElement('h3');
    title.textContent = type;
    groupDiv.appendChild(title);
    
    const optionsDiv = document.createElement('div');
    optionsDiv.className = 'property-options';
    
    properties.forEach(property => {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'property-option';
      optionDiv.dataset.propertyId = property.id;
      optionDiv.dataset.propertyType = property.type;
      optionDiv.dataset.propertyTitle = property.title;
      
      if (property.icon) {
        const img = document.createElement('img');
        img.src = property.icon;
        img.alt = property.title;
        img.className = 'property-icon';
        img.width = 24;
        img.height = 24;
        optionDiv.appendChild(img);
      }
      
      const titleSpan = document.createElement('span');
      titleSpan.className = 'property-title';
      titleSpan.textContent = property.title;
      
      optionDiv.appendChild(titleSpan);
      
            if(property.title === "Colores"){
              const colorSpan = document.createElement('span');
              colorSpan.className = 'product-option-color';
              colorSpan.style.background = 'linear-gradient(125deg,#0ff 21%,#f0f 49%,#ff0 76%)';
              optionDiv.appendChild(colorSpan);
            }
      
            if(property.title === "En Blanco Y Negro"){
              const colorSpan = document.createElement('span');
              colorSpan.className = 'product-option-color';
              colorSpan.style.background = 'linear-gradient(125deg,#000 9%,#fff 73%)';
              optionDiv.appendChild(colorSpan);
            }
      
      if (property.label) {
        const badge = document.createElement('span');
        badge.className = 'badge';
        badge.textContent = property.label;
        optionDiv.appendChild(badge);
      }
      
      optionDiv.addEventListener('click', function() {
        // Remover clase active de otras opciones del mismo tipo
        const sameTypeOptions = groupDiv.querySelectorAll('.property-option');
        sameTypeOptions.forEach(opt => opt.classList.remove('active'));
        
        // Agregar clase active a la opción seleccionada
        this.classList.add('active');
        
        // Actualizar inputs en el formulario
        updateFormProperty(type, property.title);
      });
      
      optionsDiv.appendChild(optionDiv);
    });
    
    groupDiv.appendChild(optionsDiv);
    propertiesContainer.appendChild(groupDiv);
  });
  
  function updateFormProperty(type, title) {
    // Remover input existente para este tipo
    const existingInput = form.querySelector(`input[name="properties[${type}]"]`);
    if (existingInput) {
      existingInput.remove();
    }
    
    // Crear nuevo input
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${type}]`;
    input.value = title;
    form.appendChild(input);
  }
});
